webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_particles_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_particles_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__vue_particles_vue__);



var VueParticles = {
    install: function install(Vue, options) {
        Vue.component('vue-particles', __WEBPACK_IMPORTED_MODULE_0__vue_particles_vue___default.a);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (VueParticles);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(15)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(27),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css_normalize_css__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_normalize_css_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismjs_themes_prism_css__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismjs_themes_prism_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prismjs_themes_prism_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prismjs_themes_prism_okaidia_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prismjs_themes_prism_okaidia_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prismjs_themes_prism_okaidia_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_tables_scss__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_tables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_tables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__vue_particles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_prism__ = __webpack_require__(8);











__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__vue_particles__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_vue_prism__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App___default.a }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Foot__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Foot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Foot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Main__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Main__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Foot: __WEBPACK_IMPORTED_MODULE_0__components_Foot___default.a,
    MainContent: __WEBPACK_IMPORTED_MODULE_1__components_Main___default.a
  },
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'foot',
  data: function data() {
    return {
      msg: 'This is footer!!!'
    };
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

var appCode = '<template>\n    <div id="app">\n      <vue-particles color="#dedede"></vue-particles>\n    </div>\n </template>';
var appCodeFull = '<template>\n    <div id="app">\n      <vue-particles\n        color="#dedede"\n        :particleOpacity="0.7"\n        :particlesNumber="80"\n        shapeType="circle"\n        :particleSize="4"\n        linesColor="#dedede"\n        :linesWidth="1"\n        :lineLinked="true"\n        :lineOpacity="0.4"\n        :linesDistance="150"\n        :moveSpeed="3"\n        :hoverEffect="true"\n        hoverMode="grab"\n        :clickEffect="true"\n        clickMode="push"\n      >\n      </vue-particles>\n    </div>\n </template>';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-content',
  data: function data() {
    return {
      appCode: appCode,
      appCodeFull: appCodeFull
    };
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vue-particles',
  data: function data() {
    return {
      id: 'particles-instance-' + Math.floor(Math.random() * 5000)
    };
  },
  props: {
    color: {
      type: String,
      default: '#dedede'
    },
    particleOpacity: {
      type: Number,
      default: 0.7
    },
    particlesNumber: {
      type: Number,
      default: 80
    },
    shapeType: {
      type: String,
      default: 'circle'
    },
    particleSize: {
      type: Number,
      default: 4
    },
    linesColor: {
      type: String,
      default: '#dedede'
    },
    linesWidth: {
      type: Number,
      default: 1
    },
    lineLinked: {
      type: Boolean,
      default: true
    },
    lineOpacity: {
      type: Number,
      default: 0.4
    },
    linesDistance: {
      type: Number,
      default: 150
    },
    moveSpeed: {
      type: Number,
      default: 3
    },
    hoverEffect: {
      type: Boolean,
      default: true
    },
    hoverMode: {
      type: String,
      default: 'grab'
    },
    clickEffect: {
      type: Boolean,
      default: true
    },
    clickMode: {
      type: String,
      default: 'push'
    }
  },
  mounted: function mounted() {
    var _this = this;

    __webpack_require__(16);
    this.$nextTick(function () {
      _this.initParticleJS(_this.color, _this.particleOpacity, _this.particlesNumber, _this.shapeType, _this.particleSize, _this.linesColor, _this.linesWidth, _this.lineLinked, _this.lineOpacity, _this.linesDistance, _this.moveSpeed, _this.hoverEffect, _this.hoverMode, _this.clickEffect, _this.clickMode);
    });
  },

  methods: {
    initParticleJS: function initParticleJS(color, particleOpacity, particlesNumber, shapeType, particleSize, linesColor, linesWidth, lineLinked, lineOpacity, linesDistance, moveSpeed, hoverEffect, hoverMode, clickEffect, clickMode) {
      particlesJS(this.id, {
        "particles": {
          "number": {
            "value": particlesNumber,
            "density": {
              "enable": true,
              "value_area": 800
            }
          },
          "color": {
            "value": color
          },
          "shape": {
            "type": shapeType,
            "stroke": {
              "width": 0,
              "color": "#192231"
            },
            "polygon": {
              "nb_sides": 5
            }
          },
          "opacity": {
            "value": particleOpacity,
            "random": false,
            "anim": {
              "enable": false,
              "speed": 1,
              "opacity_min": 0.1,
              "sync": false
            }
          },
          "size": {
            "value": particleSize,
            "random": true,
            "anim": {
              "enable": false,
              "speed": 40,
              "size_min": 0.1,
              "sync": false
            }
          },
          "line_linked": {
            "enable": lineLinked,
            "distance": linesDistance,
            "color": linesColor,
            "opacity": lineOpacity,
            "width": linesWidth
          },
          "move": {
            "enable": true,
            "speed": moveSpeed,
            "direction": "none",
            "random": false,
            "straight": false,
            "out_mode": "out",
            "bounce": false,
            "attract": {
              "enable": false,
              "rotateX": 600,
              "rotateY": 1200
            }
          }
        },
        "interactivity": {
          "detect_on": "canvas",
          "events": {
            "onhover": {
              "enable": hoverEffect,
              "mode": hoverMode
            },
            "onclick": {
              "enable": clickEffect,
              "mode": clickMode
            },
            "onresize": {

              "enable": true,
              "density_auto": true,
              "density_area": 400

            }
          },
          "modes": {
            "grab": {
              "distance": 140,
              "line_linked": {
                "opacity": 1
              }
            },
            "bubble": {
              "distance": 400,
              "size": 40,
              "duration": 2,
              "opacity": 8,
              "speed": 3
            },
            "repulse": {
              "distance": 200,
              "duration": 0.4
            },
            "push": {
              "particles_nb": 4
            },
            "remove": {
              "particles_nb": 2
            }
          }
        },
        "retina_detect": true
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(26),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(24),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(25),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_c('h3', {
    staticClass: "section-title teko white"
  }, [_vm._v("\n      How to use\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "wrap-code text-left"
  }, [_c('h4', {
    staticClass: "white"
  }, [_vm._v("\n        App.vue file - Simple example\n      ")]), _vm._v(" "), _c('pre', {
    staticClass: "language-html"
  }, [_c('code', [_vm._v("\n" + _vm._s(_vm.appCode) + "\n        ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "wrap-code text-left"
  }, [_c('h4', {
    staticClass: "white"
  }, [_vm._v("\n        App.vue file - Full example\n      ")]), _vm._v(" "), _c('pre', {
    staticClass: "language-html"
  }, [_c('code', [_vm._v("\n" + _vm._s(_vm.appCodeFull) + "\n        ")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "npm-code white"
  }, [_vm._v("              "), _c('code', [_vm._v("\nnpm install vue-particles --save-dev\n              ")]), _vm._v("\n     ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap-code text-left"
  }, [_c('h4', {
    staticClass: "white"
  }, [_vm._v("\n        Main.js file\n      ")]), _vm._v(" "), _c('pre', {
    staticClass: "language-js"
  }, [_c('code', [_vm._v("\nimport Vue from 'vue'\nimport VueParticles from 'vue-particles'\nVue.use(VueParticles)\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap-table"
  }, [_c('h4', {
    staticClass: "white text-left"
  }, [_vm._v("\n       Props\n      ")]), _vm._v(" "), _c('table', {
    staticClass: "rwd-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("color")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("#dedede")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("Particle color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("particleOpacity")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("0.7")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("Particle opacity")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("particlesNumber")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("80")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("Amount of particles")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("shapeType")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("\"circle\"")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Available shape types: \"circle\",\"edge\",\"triangle\",\n            \"polygon\",\"star\"\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("particleSize")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Size of single particle\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("linesColor")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("#dedede")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Lines color\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("linesWidth")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Lines width\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("lineLinked")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Boolean")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("true")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Enable lines\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("lineOpacity")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("0.4")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Line opacity\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("linesDistance")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("150")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Lines distance\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("moveSpeed")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Particles speed\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("hoverEffect")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Boolean")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("true")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Enable hover effect\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("hoverMode")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("grab")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Available hover modes:\n            \"grab\", \"repulse\", \"bubble\"\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("clickEffect")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("Boolean")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("true")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Enable click effect\n          ")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "data-th": "Name"
    }
  }, [_vm._v("clickMode")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Type"
    }
  }, [_vm._v("String")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Default"
    }
  }, [_vm._v("push")]), _vm._v(" "), _c('td', {
    attrs: {
      "data-th": "Description"
    }
  }, [_vm._v("\n            Available click modes:\n            \"push\", \"remove\", \"repulse\", \"bubble\"\n          ")])])])])
}]}

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "particles-js",
    attrs: {
      "id": _vm.id,
      "color": _vm.color,
      "particleOpacity": _vm.particleOpacity,
      "linesColor": _vm.linesColor,
      "particlesNumber": _vm.particlesNumber,
      "shapeType": _vm.shapeType,
      "particleSize": _vm.particleSize,
      "linesWidth": _vm.linesWidth,
      "lineLinked": _vm.lineLinked,
      "lineOpacity": _vm.lineOpacity,
      "linesDistance": _vm.linesDistance,
      "moveSpeed": _vm.moveSpeed,
      "hoverEffect": _vm.hoverEffect,
      "hoverMode": _vm.hoverMode,
      "clickEffect": _vm.clickEffect,
      "clickMode": _vm.clickMode
    }
  })
},staticRenderFns: []}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer text-center"
  }, [_c('p', {
    staticClass: "white"
  }, [_vm._v("\n    created by creotip.io\n  ")])])
}]}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "wrap-banner"
  }, [_vm._m(0), _vm._v(" "), _c('vue-particles', {
    attrs: {
      "color": "#ffffff",
      "particleOpacity": 0.7,
      "linesColor": "#ffffff",
      "particlesNumber": 80,
      "shapeType": "circle",
      "particleSize": 5,
      "linesWidth": 2,
      "lineLinked": true,
      "lineOpacity": 0.4,
      "linesDistance": 150,
      "moveSpeed": 3,
      "hoverEffect": true,
      "hoverMode": "grab",
      "clickEffect": true,
      "clickMode": "push"
    }
  })], 1), _vm._v(" "), _c('main-content'), _vm._v(" "), _c('foot')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-title"
  }, [_c('h2', [_vm._v("\n        Vue-Particles\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("\n        Vue.js component for particles backgrounds\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("\n        SSR compatible\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "gh-button",
    attrs: {
      "target": "_blank",
      "href": "https://github.com/creotip/vue-particles"
    }
  }, [_c('span', {
    staticClass: "gh-button__icon"
  }), _vm._v("Download")])])
}]}

/***/ })
],[10]);


// WEBPACK FOOTER //
// static/js/app.fbb9ee1048527f0f771d.js